export const isDesktopShellEnvironment = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const hasWailsRuntime =
    typeof (window as { runtime?: unknown }).runtime !== "undefined" ||
    typeof (window as { go?: unknown }).go !== "undefined" ||
    typeof (window as { __WAILS__?: unknown }).__WAILS__ !== "undefined";

  return (
    hasWailsRuntime ||
    /wails|webview2|;\s*wv\)/i.test(userAgent) ||
    window.location.hostname === "wails.localhost"
  );
};
